import { useAutoneTranslation } from '@autone/translations';
import { forwardRef } from 'react';

import { Button, type ButtonProps, cn } from '../../../../tailwind';
import { useChangeFiltersPopoverViewContext } from '../ChangeFiltersPopoverView.context';
import { useActiveFiltersCount } from '../hooks';

export const SaveFiltersSelectionButton = forwardRef<
  HTMLButtonElement,
  ButtonProps
>(({ className, ...props }, ref) => {
  const { common } = useAutoneTranslation();
  const [, dispatch] = useChangeFiltersPopoverViewContext();

  const { activeFiltersCount } = useActiveFiltersCount();
  return (
    <Button
      variant="outlined"
      color="primary"
      className={cn('h-8', className)}
      onClick={() => dispatch({ type: 'GO_TO', payload: 'template' })}
      disabled={!activeFiltersCount}
      ref={ref}
      {...props}
    >
      {common('filters.save-selection')}
    </Button>
  );
});
